import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Modal from 'react-modal';
import CloseIcon from '@images/owner/close.svg';
import CopyIcon from '@images/owner/content_copy.svg';
import EarthIcon from '@images/owner/earth.svg';
import LockBlackIcon from '@images/owner/lockBlack.svg';
import PrivateEarthRoverIcon from '@images/owner/privateEarthRover.svg';
import LockIcon from '@images/owner/lock.svg';
import { createBotAccessInvitation, sentBotAccessInvitationData, rovokeRideBotAccessInvitation } from '@services/api';
import copy from "copy-to-clipboard";
import toastErrorMessages from "@util/toastErrorMessage";

const ShareEarthRoverModal = ({ shareBot }) => {
    // Note: a stray `props` prop used to be threaded all the way down from
    // pages/owner/dashboard.js so this modal could pull `props.location.origin`.
    // That `location` was a Gatsby/@reach-router injection — Next.js Pages
    // Router doesn't inject `location` on page components, so it arrived
    // undefined and `location.origin` threw on every share-link click.
    // Use the browser global directly here; this handler only fires from a
    // user click so window is guaranteed available.
    const modal = useModal();
    const [linkColor, setLinkColor] = useState('#000');
    const [botAccessInvitationRes, setBotAccessInvitationRes] = useState();
    const [timeDifference, setTimeDifference] = useState({ diffHours: 0, diffMinutes: 0 });

    useEffect(() => {
        sentBotAccessInvitationDataHandler()
    }, [shareBot]);

    const makePublicHandler = async () => {
        const createBotAccessInvitationRes = await createBotAccessInvitation(shareBot.device_ref_id);
        if (createBotAccessInvitationRes && createBotAccessInvitationRes.error) {
            toast.error(`${createBotAccessInvitationRes.error}`, { position: "top-right" })
        } else {
            setBotAccessInvitationRes(createBotAccessInvitationRes);
            toast.success(toastErrorMessages.makePublic, { position: "top-right" });
        }
    }

    const copyToLinkHandler = () => {
        const origin = typeof window !== 'undefined' ? window.location.origin : '';
        copy(`${origin}/join/${botAccessInvitationRes?.access_token}`)
        setLinkColor('#008735')
    }

    const sentBotAccessInvitationDataHandler = async () => {
        const sentBotAccessInvitationResponce = await sentBotAccessInvitationData();
        console.log('createBotAccessInvitationRes', sentBotAccessInvitationResponce, shareBot, shareBot?.bot_activation?.activation_code)
        if (sentBotAccessInvitationResponce.bot_access_invitations.length > 0) {
            const botAccessInvitation = sentBotAccessInvitationResponce.bot_access_invitations.find((item) => (item.bot.name === shareBot?.bot_activation?.activation_code && item.expired === false && item.enabled === true))
            console.log('botAccessInvitation: ', botAccessInvitation);
            if (botAccessInvitation) {
                setBotAccessInvitationRes(botAccessInvitation)
            } else {
                setBotAccessInvitationRes()
            }
        }
    }

    const rovokeRideBotAccessInvitationHandler = async () => {
        const rovokeRideBotAccessInvitationResponce = await rovokeRideBotAccessInvitation(botAccessInvitationRes?.access_token);
        console.log('rovokeRideBotAccessInvitationResponce: ', rovokeRideBotAccessInvitationResponce);
        if (rovokeRideBotAccessInvitationResponce && rovokeRideBotAccessInvitationResponce.error) {
            toast.error(`${rovokeRideBotAccessInvitationResponce.error}`, { position: "top-right" })
        } else {
            toast.success(toastErrorMessages.makePrivate, { position: "top-right" });
            setBotAccessInvitationRes()
        }
    }

    const closeModal = () => {
        modal.hide();
        setLinkColor('#000')
    }

    useEffect(() => {
        if (botAccessInvitationRes?.expires_at) {
            const expiresAt = new Date(botAccessInvitationRes.expires_at);
            if (!isNaN(expiresAt.getTime())) {
                const now = new Date();
                const diffMs = expiresAt - now;

                if (diffMs > 0) {
                    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                    setTimeDifference({ diffHours, diffMinutes });
                } else {
                    setTimeDifference({ diffHours: 0, diffMinutes: 0 });
                }
            } else {
                setTimeDifference({ diffHours: 0, diffMinutes: 0 });
            }
        }
    }, [botAccessInvitationRes]);

    return (
        <Modal
            isOpen={modal.visible}
            ariaHideApp={false}
            className="mymodal w-full"
            onRequestClose={closeModal}
        >
            <div className="flex w-full mx-6 sm:w-[800px] p-[16px] flex-col items-start gap-[16px] rounded-[32px] bg-[#F1F1F1] overflow-y-auto max-h-[300px] sm:max-h-[230px] h-full">
                <div className="w-full flex px-[16px] py-[6px] justify-between items-center rounded-[16px]">
                    <p className="text-[#000] sm:ml-[33.33%] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px]">
                        Share Earth Rover #1
                    </p>
                    <button onClick={closeModal}>
                        <img src={CloseIcon} alt="Close Icon" className='w-[24px] h-[24px]' />
                    </button>
                </div>
                <div className='w-full flex p-[8px] sm:p-[12px] items-center gap-[13px] rounded-[12px] border-[1px] border-[solid] border-[#DDD] bg-[#F3F3F3]'>
                    <div className='w-full flex flex-col justify-center items-start gap-[16px]'>
                        <div className='flex pb-[16px] items-center gap-[8px] border-b-[1px] border-b-solid border-b-[#EBEBEB]'>
                            {
                                botAccessInvitationRes?.access_token ?
                                    <div className='flex p-[4px] sm:p-[8px] items-center rounded-full bg-[#0A6AF3] min-w-[28px]'>
                                        <img src={PrivateEarthRoverIcon} alt="LockBlack Icon" className='w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]' />
                                    </div>
                                    :
                                    <div className='flex p-[4px] sm:p-[8px] items-center rounded-full bg-[#DDD] min-w-[28px]'>
                                        <img src={LockBlackIcon} alt="LockBlack Icon" className='w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]' />
                                    </div>
                            }
                            <div className='flex flex-col justify-center items-start gap-[4px]'>
                                {
                                    botAccessInvitationRes?.access_token ?
                                        <>
                                            <p className='text-[#4B4B4B] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Your Earth Rover can be shared for a limited time.</p>
                                            <p className='text-[#4B4B4B] text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]'>Your link will be automatically private in: <span className='text-[#2D74FF]'>{timeDifference?.diffHours}h {timeDifference?.diffMinutes}m</span>. You can make the Earth Rover public again to renew the timer.</p>
                                        </>
                                        :
                                        <>
                                            <p className='text-[#4B4B4B] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Your Earth Rover is private.</p>
                                            <p className='text-[#4B4B4B] text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]'>No one except you can drive the Earth Rover.</p>
                                        </>
                                }
                            </div>
                        </div>
                        <div className='flex items-center gap-[8px]'>
                            {
                                botAccessInvitationRes?.access_token &&
                                <button className={`flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#727272] bg-[${linkColor}]`} onClick={copyToLinkHandler}>
                                    <img src={CopyIcon} alt="Copy Icon" className='w-[20px] h-[20px]' />
                                    <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Copy Link</p>
                                </button>
                            }
                            {
                                botAccessInvitationRes?.access_token ?
                                    <button className='flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#727272] bg-[#000]' onClick={rovokeRideBotAccessInvitationHandler}>
                                        <img src={LockIcon} alt="Lock Icon" className='w-[20px] h-[20px]' />
                                        <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Make private</p>
                                    </button>
                                    :
                                    <button className='flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#727272] bg-[#000]' onClick={makePublicHandler}>
                                        <img src={EarthIcon} alt="Lock Icon" className='w-[20px] h-[20px]' />
                                        <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Make Public</p>
                                    </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default NiceModal.create(ShareEarthRoverModal);